
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2651',
  depVersions: {
  "customer-portal-app": "static-1.2651",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.479",
  "data-fetching-client": "static-1.9774",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25711",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5703",
  "hs-test-utils": "static-1.8133",
  "hub-http": "static-1.6334",
  "hub-http-shared-msw-handlers": "static-1.10241",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18559",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11588",
  "I18n": "static-7.1637",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6570",
  "payment-link-components": "static-1.23821",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7169",
  "quartz-core": "static-1.6388",
  "quartz-i18n": "static-1.844",
  "react": "static-7.187",
  "react-colorpicker": "static-2.10319",
  "react-dlb": "static-1.81",
  "react-utils": "static-2.5423",
  "rich-text-lib": "static-1.20025",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18146",
  "ui-components-test-utils": "static-1.5725",
  "UIComponents": "static-3.8534",
  "foundations-assets": "static-1.4985",
  "foundations-components": "static-1.8150",
  "foundations-theming": "static-1.4542",
  "foundations-theming-specialty": "static-1.2258",
  "framer-motion": "static-1.73",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.1166",
  "quartz-config": "static-1.947",
  "quartz-routing": "static-1.599",
  "quick-fetch": "static-1.3999",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16796",
  "rpc-client-utils": "static-1.4768",
  "sanitize-text": "static-1.8257",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.56",
  "ui-addon-draggable": "static-3.4871",
  "ui-addon-react-router-dom": "static-1.9649",
  "usage-tracker": "static-1.7460",
  "usage-tracker-anonymous": "static-1.5877",
  "usage-tracker-core": "static-1.7310",
  "video-components-external": "static-1.11641",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3479",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3446",
  "quartz-webpack": "static-1.3393",
  "bend-plugin-quartz-routing": "static-1.247",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.83",
  "customer-data-objects": "static-1.7791",
  "frontend-preferences-client": "static-1.8039",
  "laboratory-lib": "static-3.7265",
  "onboarding-scopes": "static-1.6573",
  "seat-types-lib": "static-1.270",
  "ui-addon-opt": "static-4.8473",
  "HeadJS": "static-2.768",
  "hs-test-utils-bend-plugin": "static-1.3244",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "hs-locale-management": "static-1.163",
  "ts-schema": "static-1.4162",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7930",
  "content-media-capture": "static-1.4854",
  "cssUtils": "static-1.823",
  "customer-data-ui-utilities": "static-1.9937",
  "file-manager-components": "static-1.23931",
  "HubStyle": "static-2.11895",
  "knowledge-content-types": "static-1.8559",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.489",
  "ui-addon-emoji-picker": "static-1.9998",
  "ui-addon-i18n": "static-1.11260",
  "ui-business-units-lib": "static-1.9178",
  "ui-shepherd-react": "static-3.10349",
  "video-data-lib": "static-1.35299",
  "i18n-data": "static-1.223",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4437",
  "commerce-tours-lib": "static-1.6304",
  "customer-data-properties": "static-1.51967",
  "getting-started-shared-tasks": "static-1.18725",
  "growth-onboarding-reliability": "static-1.5192",
  "onboarding-tours": "static-1.16812",
  "reference-resolvers-lite": "static-1.8210",
  "sales-checkout-service-client": "static-1.3705",
  "ui-addon-iframeable": "static-1.9179",
  "user-context": "static-1.5222",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.844",
  "hubspotter-http": "static-1.4732",
  "icons": "static-2.653",
  "mobile-manifest-mixins": "static-1.543",
  "module-federation": "static-1.27",
  "quartz-auth": "static-1.844",
  "quartz-head": "static-1.834",
  "quartz-test": "static-1.844",
  "quartz-tracking": "static-1.548",
  "trellis-components": "static-1.2208",
  "ui-fonts": "static-1.850",
  "usage-tracker-container": "static-1.7450",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9534",
  "data-token-picker": "static-1.16604",
  "FileManagerLib": "static-1.39571",
  "property-translator": "static-1.5508",
  "atom": "static-1.5187",
  "merchandise-lib": "static-1.266",
  "purchase-motions-components": "static-1.6085",
  "salesImages": "static-1.527",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5633",
  "react-create-root-preference": "static-1.35",
  "react-select-plus": "static-1.106",
  "react-virtualized": "static-2.100",
  "ui-images": "static-2.1180",
  "bend-plugin-foundations-components": "static-1.4419",
  "floating-ui": "static-1.57",
  "react-aria": "static-1.67",
  "trellis-assets": "static-1.2189",
  "bend-plugin-foundations-theming": "static-1.3025",
  "foundations-theming-base": "static-1.3527",
  "stylex": "static-1.34",
  "interframe": "static-3.4872",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5874",
  "web-vitals": "static-1.7",
  "bend-plugin-chirp-manifest": "static-1.178",
  "chirp-fetch": "static-1.1998",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4587",
  "react-flip-move": "static-1.72",
  "apollo-link-hub-http": "static-2.4763",
  "content-media-composition-data-lib": "static-1.12658",
  "content-media-compositions": "static-2.16665",
  "idb-keyval": "static-1.45",
  "immer": "static-1.33",
  "immerable": "static-1.4262",
  "magpie-lib": "static-1.5625",
  "magpie-types": "static-1.5085",
  "media-bridge-lib": "static-1.19120",
  "bender-build-tools": "static-1.3281",
  "inbound-db-properties-service-client": "static-1.3926",
  "superstore": "static-1.4871",
  "feedback-loader": "static-1.29507",
  "ai-components-ui-library": "static-1.9239",
  "ui-addon-video-player": "static-1.8815",
  "ui-coaching-tips": "static-1.28873",
  "ContentUtils": "static-1.68687",
  "fix-webm-duration": "static-1.24",
  "notification-sounds": "static-1.4536",
  "sassPrefix": "static-1.158",
  "react-dnd-compat": "static-1.4727",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2609",
  "navigation-messaging": "static-1.7615",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8286",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9964",
  "crm-message-bus": "static-1.43276",
  "growth-data-modal": "static-1.5606",
  "hubspot-apollo-client": "static-1.4990",
  "onboarding-tours-client": "static-1.5026",
  "calling-global-api": "static-1.64900",
  "calling-internal-common": "static-1.31421",
  "calling-lifecycle-internal": "static-1.66282",
  "calling-lifecycle-messages": "static-1.58576",
  "conditional-properties-service-client": "static-1.3877",
  "crm-links": "static-1.6420",
  "crm-pipelines-api-client-types": "static-1.4218",
  "customer-data-objects-ui-components": "static-1.13142",
  "customer-data-properties-shared-msw-handlers": "static-1.9568",
  "customer-data-property-utils": "static-1.8207",
  "external-options-client-types": "static-1.4209",
  "framework-data-schema-resolvers": "static-1.7004",
  "google-libphonenumber": "static-1.39",
  "hs-resources": "static-1.284",
  "inbound-db-meta-service-client": "static-1.3668",
  "inbounddb-objects-service-types": "static-1.4298",
  "meetings-icalendar-utils-lib": "static-1.745",
  "multi-currency-client-types": "static-1.3771",
  "object-builder-ui-client": "static-1.49133",
  "pipeline-validation-client-types": "static-1.4048",
  "property-value-citations": "static-1.2581",
  "pulse": "static-1.709",
  "smart-property-lib": "static-1.7788",
  "tiered-pricing": "static-1.1509",
  "ui-addon-form-validation": "static-1.11101",
  "zustand": "static-1.74",
  "growth-onboarding-confetti": "static-1.3177",
  "growth-onboarding-next-action-utils": "static-1.2242",
  "navigation-components": "static-1.18288",
  "onboarding-tours-utils": "static-1.878",
  "ui-shepherd-tracker": "static-1.7730",
  "ui-universal-auth": "static-1.9111",
  "batch-promise": "static-1.1654",
  "getting-started-shared-tasks-store": "static-1.17843",
  "hubspotter-http-shared-msw-handlers": "static-1.10239",
  "usage-tracker-session-replay": "static-1.5146",
  "base-ui": "static-1.13",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1053",
  "tanstack-virtual": "static-1.31",
  "audio-components": "static-1.6088",
  "FileManagerCore": "static-1.39430",
  "FileManagerImages": "static-1.37082",
  "video-components": "static-1.13643",
  "foundations-components-legacy": "static-1.1175",
  "purchase-motions-api": "static-1.6088",
  "signup-constants": "static-1.19112",
  "signup-ui-url-generator": "static-2.8170",
  "usage-tracker-public": "static-1.7271",
  "reactive-lib": "static-1.837",
  "simple-logging-lib": "static-1.3161",
  "chatspot-core": "static-1.21828",
  "copilot-toolkit": "static-1.11426",
  "growth-onboarding-feedback-components": "static-1.6691",
  "cms-field-types": "static-1.4927",
  "content-icons-ui": "static-1.2257",
  "integrations-lib": "static-1.16512",
  "underscore": "static-1.8",
  "commerce-permissions": "static-1.888",
  "customer-data-tracking": "static-1.7000",
  "products-iframe-lib": "static-1.8242",
  "products-ui-components-shared-msw-handlers": "static-1.10623",
  "restore-request-side-panel-lib": "static-1.1159",
  "onboarding-data-sync-lib": "static-1.2152",
  "hubspot-apollo-cache": "static-1.449",
  "calling-error-reporting": "static-1.31428",
  "shared-worker-versioning": "static-1.11147",
  "calling-usage-tracker": "static-1.6655",
  "voice-sms-access-library": "static-1.1431",
  "conversations-skeleton-state": "static-1.7359",
  "location-customization-utils-lib": "static-1.9592",
  "fdsr-migration-layer": "static-1.123",
  "framework-builder-read-service-client": "static-1.4086",
  "framework-data-schema-quick-fetch": "static-1.6909",
  "persist-promise": "static-1.3811",
  "event-emitter": "static-1.1061",
  "bend-plugin-pulse": "static-1.212",
  "fast-json-patch": "static-1.64",
  "data-agent-kit": "static-1.378",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10324",
  "fsm": "static-1.3840",
  "policy-lib": "static-1.6893",
  "react-tinymce": "static-1.55539",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10387",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54665",
  "tinymce-plugins": "static-1.57779",
  "tinymce-themes": "static-1.56635",
  "growth-onboarding-next-action-components": "static-1.2270",
  "user-context-client": "static-1.4692",
  "nest": "static-1.344",
  "unified-auth-core-lib": "static-1.907",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.55",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4647",
  "video-embed": "static-1.36133",
  "social-insights-client-types": "static-1.22323",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1109",
  "flux-actions": "static-1.345",
  "integrations-error-boundary-lib": "static-1.13927",
  "integrations-tracking-lib": "static-1.5718",
  "native-integrations-shared-strings": "static-1.7895",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10474",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.625",
  "sales-views-client-types": "static-1.4368",
  "InboxConnectUtils": "static-4.15107",
  "meetings-connect-utils-lib": "static-1.7717",
  "calling-orchestration-schema": "static-1.36208",
  "crm-record-cards-service-types": "static-1.3671",
  "highcharts": "static-8.105",
  "trellis-story-utils": "static-1.4624",
  "storybook-react": "static-1.34",
  "hub-http-contrib": "static-1.3155",
  "tinymce-data": "static-1.40750",
  "ui-addon-sales-email": "static-1.5321",
  "codemirror": "static-5.96",
  "layout-dnd-components": "static-1.12662",
  "layout-dnd-utils": "static-1.11637",
  "react-codemirror": "static-1.10739",
  "ui-brand-identity-lib": "static-1.15685",
  "NamespacedHubStyle": "static-2.9136",
  "outpost": "static-1.4282",
  "breeze-engine-core": "static-1.387",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "universal-page-editor-lib": "static-1.3129",
  "adobe-sign-auth-lib": "static-1.7",
  "ads-unified-auth-lib": "static-1.361",
  "google-sheets-integration-lib": "static-1.570",
  "microsoft-drive-integration-lib": "static-1.701",
  "surveymonkey-integration-lib": "static-1.27",
  "slack-ui-library": "static-1.10506",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68762",
  "layout-data-lib": "static-1.9962",
  "browser-eslint": "static-2.57",
  "advanced-menus-core": "static-1.15312",
  "advanced-menus-lib": "static-1.12225",
  "ExportDialog": "static-6.10491",
  "ui-memberships-settings-lib": "static-1.34343",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15311",
  "simple-menus-lib": "static-1.16828"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2651",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.479",
  "data-fetching-client": "/data-fetching-client/static-1.9774",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25711",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5703",
  "hs-test-utils": "/hs-test-utils/static-1.8133",
  "hub-http": "/hub-http/static-1.6334",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10241",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18559",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11588",
  "I18n": "/I18n/static-7.1637",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6570",
  "payment-link-components": "/payment-link-components/static-1.23821",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7169",
  "quartz-core": "/quartz-core/static-1.6388",
  "quartz-i18n": "/quartz-i18n/static-1.844",
  "react": "/react/static-7.187",
  "react-colorpicker": "/react-colorpicker/static-2.10319",
  "react-dlb": "/react-dlb/static-1.81",
  "react-utils": "/react-utils/static-2.5423",
  "rich-text-lib": "/rich-text-lib/static-1.20025",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18146",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5725",
  "UIComponents": "/UIComponents/static-3.8534",
  "foundations-assets": "/foundations-assets/static-1.4985",
  "foundations-components": "/foundations-components/static-1.8150",
  "foundations-theming": "/foundations-theming/static-1.4542",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2258",
  "framer-motion": "/framer-motion/static-1.73",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.1166",
  "quartz-config": "/quartz-config/static-1.947",
  "quartz-routing": "/quartz-routing/static-1.599",
  "quick-fetch": "/quick-fetch/static-1.3999",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16796",
  "rpc-client-utils": "/rpc-client-utils/static-1.4768",
  "sanitize-text": "/sanitize-text/static-1.8257",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.56",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4871",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9649",
  "usage-tracker": "/usage-tracker/static-1.7460",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5877",
  "usage-tracker-core": "/usage-tracker-core/static-1.7310",
  "video-components-external": "/video-components-external/static-1.11641",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3479",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3446",
  "quartz-webpack": "/quartz-webpack/static-1.3393",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.247",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.83",
  "customer-data-objects": "/customer-data-objects/static-1.7791",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8039",
  "laboratory-lib": "/laboratory-lib/static-3.7265",
  "onboarding-scopes": "/onboarding-scopes/static-1.6573",
  "seat-types-lib": "/seat-types-lib/static-1.270",
  "ui-addon-opt": "/ui-addon-opt/static-4.8473",
  "HeadJS": "/HeadJS/static-2.768",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3244",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "hs-locale-management": "/hs-locale-management/static-1.163",
  "ts-schema": "/ts-schema/static-1.4162",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7930",
  "content-media-capture": "/content-media-capture/static-1.4854",
  "cssUtils": "/cssUtils/static-1.823",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9937",
  "file-manager-components": "/file-manager-components/static-1.23931",
  "HubStyle": "/HubStyle/static-2.11895",
  "knowledge-content-types": "/knowledge-content-types/static-1.8559",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.489",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9998",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11260",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9178",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10349",
  "video-data-lib": "/video-data-lib/static-1.35299",
  "i18n-data": "/i18n-data/static-1.223",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4437",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6304",
  "customer-data-properties": "/customer-data-properties/static-1.51967",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18725",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5192",
  "onboarding-tours": "/onboarding-tours/static-1.16812",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8210",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3705",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9179",
  "user-context": "/user-context/static-1.5222",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.844",
  "hubspotter-http": "/hubspotter-http/static-1.4732",
  "icons": "/icons/static-2.653",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.543",
  "module-federation": "/module-federation/static-1.27",
  "quartz-auth": "/quartz-auth/static-1.844",
  "quartz-head": "/quartz-head/static-1.834",
  "quartz-test": "/quartz-test/static-1.844",
  "quartz-tracking": "/quartz-tracking/static-1.548",
  "trellis-components": "/trellis-components/static-1.2208",
  "ui-fonts": "/ui-fonts/static-1.850",
  "usage-tracker-container": "/usage-tracker-container/static-1.7450",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9534",
  "data-token-picker": "/data-token-picker/static-1.16604",
  "FileManagerLib": "/FileManagerLib/static-1.39571",
  "property-translator": "/property-translator/static-1.5508",
  "atom": "/atom/static-1.5187",
  "merchandise-lib": "/merchandise-lib/static-1.266",
  "purchase-motions-components": "/purchase-motions-components/static-1.6085",
  "salesImages": "/salesImages/static-1.527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5633",
  "react-create-root-preference": "/react-create-root-preference/static-1.35",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-virtualized": "/react-virtualized/static-2.100",
  "ui-images": "/ui-images/static-2.1180",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4419",
  "floating-ui": "/floating-ui/static-1.57",
  "react-aria": "/react-aria/static-1.67",
  "trellis-assets": "/trellis-assets/static-1.2189",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3025",
  "foundations-theming-base": "/foundations-theming-base/static-1.3527",
  "stylex": "/stylex/static-1.34",
  "interframe": "/interframe/static-3.4872",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5874",
  "web-vitals": "/web-vitals/static-1.7",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.178",
  "chirp-fetch": "/chirp-fetch/static-1.1998",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4587",
  "react-flip-move": "/react-flip-move/static-1.72",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4763",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12658",
  "content-media-compositions": "/content-media-compositions/static-2.16665",
  "idb-keyval": "/idb-keyval/static-1.45",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4262",
  "magpie-lib": "/magpie-lib/static-1.5625",
  "magpie-types": "/magpie-types/static-1.5085",
  "media-bridge-lib": "/media-bridge-lib/static-1.19120",
  "bender-build-tools": "/bender-build-tools/static-1.3281",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3926",
  "superstore": "/superstore/static-1.4871",
  "feedback-loader": "/feedback-loader/static-1.29507",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9239",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8815",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28873",
  "ContentUtils": "/ContentUtils/static-1.68687",
  "fix-webm-duration": "/fix-webm-duration/static-1.24",
  "notification-sounds": "/notification-sounds/static-1.4536",
  "sassPrefix": "/sassPrefix/static-1.158",
  "react-dnd-compat": "/react-dnd-compat/static-1.4727",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2609",
  "navigation-messaging": "/navigation-messaging/static-1.7615",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8286",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9964",
  "crm-message-bus": "/crm-message-bus/static-1.43276",
  "growth-data-modal": "/growth-data-modal/static-1.5606",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4990",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5026",
  "calling-global-api": "/calling-global-api/static-1.64900",
  "calling-internal-common": "/calling-internal-common/static-1.31421",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.66282",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58576",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3877",
  "crm-links": "/crm-links/static-1.6420",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4218",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13142",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9568",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8207",
  "external-options-client-types": "/external-options-client-types/static-1.4209",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7004",
  "google-libphonenumber": "/google-libphonenumber/static-1.39",
  "hs-resources": "/hs-resources/static-1.284",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3668",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4298",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.745",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3771",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.49133",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4048",
  "property-value-citations": "/property-value-citations/static-1.2581",
  "pulse": "/pulse/static-1.709",
  "smart-property-lib": "/smart-property-lib/static-1.7788",
  "tiered-pricing": "/tiered-pricing/static-1.1509",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11101",
  "zustand": "/zustand/static-1.74",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3177",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2242",
  "navigation-components": "/navigation-components/static-1.18288",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.878",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7730",
  "ui-universal-auth": "/ui-universal-auth/static-1.9111",
  "batch-promise": "/batch-promise/static-1.1654",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17843",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10239",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5146",
  "base-ui": "/base-ui/static-1.13",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1053",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "audio-components": "/audio-components/static-1.6088",
  "FileManagerCore": "/FileManagerCore/static-1.39430",
  "FileManagerImages": "/FileManagerImages/static-1.37082",
  "video-components": "/video-components/static-1.13643",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1175",
  "purchase-motions-api": "/purchase-motions-api/static-1.6088",
  "signup-constants": "/signup-constants/static-1.19112",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8170",
  "usage-tracker-public": "/usage-tracker-public/static-1.7271",
  "reactive-lib": "/reactive-lib/static-1.837",
  "simple-logging-lib": "/simple-logging-lib/static-1.3161",
  "chatspot-core": "/chatspot-core/static-1.21828",
  "copilot-toolkit": "/copilot-toolkit/static-1.11426",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6691",
  "cms-field-types": "/cms-field-types/static-1.4927",
  "content-icons-ui": "/content-icons-ui/static-1.2257",
  "integrations-lib": "/integrations-lib/static-1.16512",
  "underscore": "/underscore/static-1.8",
  "commerce-permissions": "/commerce-permissions/static-1.888",
  "customer-data-tracking": "/customer-data-tracking/static-1.7000",
  "products-iframe-lib": "/products-iframe-lib/static-1.8242",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10623",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.1159",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2152",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.449",
  "calling-error-reporting": "/calling-error-reporting/static-1.31428",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11147",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6655",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1431",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7359",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9592",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.123",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4086",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6909",
  "persist-promise": "/persist-promise/static-1.3811",
  "event-emitter": "/event-emitter/static-1.1061",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.212",
  "fast-json-patch": "/fast-json-patch/static-1.64",
  "data-agent-kit": "/data-agent-kit/static-1.378",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10324",
  "fsm": "/fsm/static-1.3840",
  "policy-lib": "/policy-lib/static-1.6893",
  "react-tinymce": "/react-tinymce/static-1.55539",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10387",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54665",
  "tinymce-plugins": "/tinymce-plugins/static-1.57779",
  "tinymce-themes": "/tinymce-themes/static-1.56635",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2270",
  "user-context-client": "/user-context-client/static-1.4692",
  "nest": "/nest/static-1.344",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.907",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.55",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4647",
  "video-embed": "/video-embed/static-1.36133",
  "social-insights-client-types": "/social-insights-client-types/static-1.22323",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1109",
  "flux-actions": "/flux-actions/static-1.345",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13927",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5718",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7895",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10474",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.625",
  "sales-views-client-types": "/sales-views-client-types/static-1.4368",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15107",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7717",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.36208",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3671",
  "highcharts": "/highcharts/static-8.105",
  "trellis-story-utils": "/trellis-story-utils/static-1.4624",
  "storybook-react": "/storybook-react/static-1.34",
  "hub-http-contrib": "/hub-http-contrib/static-1.3155",
  "tinymce-data": "/tinymce-data/static-1.40750",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5321",
  "codemirror": "/codemirror/static-5.96",
  "layout-dnd-components": "/layout-dnd-components/static-1.12662",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11637",
  "react-codemirror": "/react-codemirror/static-1.10739",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15685",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9136",
  "outpost": "/outpost/static-1.4282",
  "breeze-engine-core": "/breeze-engine-core/static-1.387",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3129",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.7",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.361",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.570",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.701",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.27",
  "slack-ui-library": "/slack-ui-library/static-1.10506",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68762",
  "layout-data-lib": "/layout-data-lib/static-1.9962",
  "browser-eslint": "/browser-eslint/static-2.57",
  "advanced-menus-core": "/advanced-menus-core/static-1.15312",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12225",
  "ExportDialog": "/ExportDialog/static-6.10491",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34343",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15311",
  "simple-menus-lib": "/simple-menus-lib/static-1.16828"
}
};
